import { createUseStyles } from 'react-jss';

import { Spacings } from '@picsart/design-system/foundation/spacings';
import { bleedModeOptions, FittingOptions } from '@picsart/growth-rc/old/MediaComponents';
import { PaddingOptions } from './types';

interface propsType {
  objectFit?: keyof typeof FittingOptions;
  padding?: PaddingOptions;
  imgHeight?: number | string;
  aspectRatio?: string | number;
  priority?: boolean;
}

const useStyles = createUseStyles<string, propsType>(
  {
    root: props => ({
      width: '100%',
      height: props.imgHeight || '100%',
      overflow: 'hidden',
      padding:
        props?.padding && props?.padding !== 'none' && bleedModeOptions[props?.padding]
          ? bleedModeOptions[props?.padding]?.padding
          : Spacings.s0,
      ...(!props.priority && props.aspectRatio && { aspectRatio: props.aspectRatio }),

      '& img': {
        position: 'absolute',
        display: 'block',
        boxSizing: 'border-box',
        minWidth: '100%',
        maxWidth: '100%',
        minHeight: '100%',
        maxHeight: '100%',
        backgroundSize: props.objectFit,
        inset: 0,
      },
    }),
    imgClassName: props => ({
      objectFit: props.objectFit,
      objectPosition: 'center',
      width: '100%',
      height: '100%',
    }),
  },
  {
    name: 'image',
  },
);
export default useStyles;
